export default __webpack_public_path__ + "static/media/103.b494fd3b.jpg";